"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryAppId = exports.getCountryUnderscoreLocale = exports.getCountryUserType = exports.getCountryCurrency = exports.getCountryCountry = exports.getCountryShort = exports.getCountryLocale = exports.getCountryData = exports.publicCountryList = exports.COUNTRIES = void 0;
const CountryList_1 = require("./CountryList");
const config_1 = require("./config");
exports.COUNTRIES = Object.keys(CountryList_1.COUNTRY_DATA).sort((a, b) => a.localeCompare(b));
/**
 * Function that returns a list of countries that can be seen to end user i.e. country picker on rz-web
 * It would be easier to exclude what is not needed, but its important that you write down what TO include,
 * so there are no unexpected surprises.
 */
const publicCountryList = (preview = false) => {
    return exports.COUNTRIES.filter((key) => {
        let countries = Object.keys(CountryList_1.COUNTRY_DATA);
        countries = countries.filter((country) => !config_1.EXCLUDED_COUNTRIES.includes(country) &&
            !config_1.PREVIEW_COUNTRIES.includes(country));
        if (preview) {
            countries = countries.concat(config_1.PREVIEW_COUNTRIES);
        }
        return countries.includes(key);
    });
};
exports.publicCountryList = publicCountryList;
const getCountryData = (country) => CountryList_1.COUNTRY_DATA[country] || CountryList_1.COUNTRY_DATA.si;
exports.getCountryData = getCountryData;
const getCountryLocale = (country) => (0, exports.getCountryData)(country).locale;
exports.getCountryLocale = getCountryLocale;
const getCountryShort = (locale) => (0, exports.getCountryData)(locale).short;
exports.getCountryShort = getCountryShort;
const getCountryCountry = (locale) => (0, exports.getCountryData)(locale).short;
exports.getCountryCountry = getCountryCountry;
const getCountryCurrency = (locale) => (0, exports.getCountryData)(locale).currency;
exports.getCountryCurrency = getCountryCurrency;
const getCountryUserType = (locale) => (0, exports.getCountryData)(locale).short.charAt(0).toUpperCase() +
    (0, exports.getCountryData)(locale).short.slice(1).toLowerCase();
exports.getCountryUserType = getCountryUserType;
const getCountryUnderscoreLocale = (locale) => {
    return (0, exports.getCountryData)(locale).locale.replace('-', '_');
};
exports.getCountryUnderscoreLocale = getCountryUnderscoreLocale;
const getCountryAppId = ({ locale, platform = 'Web', version = '5.8', project = 'Drugs', }) => `${platform}_${version}_${project}_${(0, exports.getCountryData)(locale).apiCountry.toUpperCase()}`;
exports.getCountryAppId = getCountryAppId;
